import React from "react";

const SelectedActorsScoresCG = ({ gameStatus, podium }) => {
  // Récupérer les acteurs sélectionnés
  const selectedActors = gameStatus.list_selected_actors;

  // Récupérer les scores des acteurs sélectionnés
  let actorScores = selectedActors.map((actor) => {
    const actorData = gameStatus.score_dic[actor];
    return {
      name: actorData.name,
      icon: actorData.icon,
      value: actorData.value,
    };
  });

  actorScores.sort((a, b) => b.value - a.value);
  if (podium) {
    actorScores = actorScores.slice(0, 3);
  }



  return (
    <div className="scoreboard-actors-container">
      {!podium ? (<h2 className="scoreboard-actors-title">Budget disponible : {gameStatus.score_dic["vote"].value}</h2>):
      (<h2 className="scoreboard-actors-title">Podium des acteurs</h2>)}
      <div className="scoreboard-actors-list">
        {actorScores.map((actor, index) => (
          <div key={index} className="scoreboard-actors-item">
            <div className="scoreboard-actors-item-left-container">
              <img src={actor.icon} alt={actor.name} className="scoreboard-actors-icon" />
              <span className="scoreboard-actors-name">{actor.name}</span>
            </div>
            <div className="scoreboard-actors-item-right-container">
              <span className="scoreboard-actors-value">{actor.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedActorsScoresCG;
